(function () {
  var cfg = window.N1M2 || {}, ar = !!cfg.ar, root = (cfg.root || '/').replace(/\/$/, ''), wide = innerWidth >= 750;
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function plp() {
    var plp = document.querySelector('.n1-plp'), tb = document.querySelector('.n1-tb'), cats = document.getElementById('n1mCats'); if (!plp || !tb || !cats) return;
    var m = location.pathname.match(/\/collections\/([^\/]+)/); if (!m) return;
    var h = m[1], pane = cats.querySelector('[data-p="' + h + '"]'), label = '';
    if (pane) { var tab = cats.querySelector('[data-t="' + h + '"]'); if (tab) label = tab.textContent.trim(); }
    else [].some.call(cats.querySelectorAll('.n1m-cats__pane'), function (p) { var a = p.querySelector('.n1m-cat-g a[href*="/collections/' + h + '"],.n1m-cat-flat a[href*="/collections/' + h + '"]'); if (a) { pane = p; label = a.textContent.trim(); return true; } });
    if (!pane) return;
    if (label) document.querySelectorAll('.n1-tb__title h1,.n1m-tb h1').forEach(function (e) { e.textContent = label; });
    var all = pane.querySelector('.n1m-cat-all'), seen = {}, html = '<a class="n1-pill' + (pane.dataset.p === h ? ' is-active' : '') + '" href="' + esc(all.getAttribute('href')) + '">' + esc(all.textContent.trim()) + '</a>';
    pane.querySelectorAll('.n1m-cat-g .n1m-circle,.n1m-cat-flat .n1m-circle').forEach(function (a) {
      var t = a.textContent.trim(); if (seen[t]) return; seen[t] = 1;
      var u = a.getAttribute('href'); html += '<a class="n1-pill' + (u.indexOf('/collections/' + h) > -1 ? ' is-active' : '') + '" href="' + esc(u) + '">' + esc(t) + '</a>';
    });
    var tr = plp.querySelector('.n1-pills__track');
    if (!tr) { var w = document.createElement('div'); w.className = 'n1-pills'; tr = document.createElement('div'); tr.className = 'n1-pills__track'; w.appendChild(tr); tb.parentNode.insertBefore(w, tb); }
    tr.innerHTML = html;
  }
  function nav() {
    var w = document.querySelector('.n1-hd__links'), bar = document.querySelector('.n1-hd__bar'), cats = document.getElementById('n1mCats'); if (!w || !bar || !cats) return;
    var items = [['makeup', 'المكياج', 'Makeup'], ['perfumes', 'العطور', 'Perfumes'], ['supplements', 'الصحة والتغذية', 'Health & nutrition']];
    var np = document.createElement('div'); np.className = 'n1d-np'; bar.appendChild(np);
    var timer, cur = null;
    function hide() { np.classList.remove('is-on'); if (cur) cur.classList.remove('is-on'); cur = null; }
    function later() { clearTimeout(timer); timer = setTimeout(hide, 160); }
    function show(a, handle) {
      clearTimeout(timer);
      var p = cats.querySelector('[data-p="' + handle + '"]'); if (!p) return;
      if (cur) cur.classList.remove('is-on'); cur = a; a.classList.add('is-on');
      var alla = p.querySelector('.n1m-cat-all'), bi = p.querySelector('.n1m-cb img'), cols = '<div class="n1d-g"><b><a href="' + esc(alla.getAttribute('href')) + '" style="color:#111;padding:0">' + esc(alla.textContent.trim()) + '</a></b></div>';
      p.querySelectorAll('.n1m-cat-g,.n1m-cat-flat').forEach(function (g) {
        var s = g.querySelector('summary'), ls = '';
        g.querySelectorAll('.n1m-circle').forEach(function (l) { ls += '<a href="' + esc(l.getAttribute('href')) + '">' + esc(l.textContent.trim()) + '</a>'; });
        cols += '<div class="n1d-g">' + (s ? '<b>' + esc(s.textContent.trim()) + '</b>' : '') + ls + '</div>';
      });
      var tiles = '';
      [].slice.call(p.querySelectorAll('.n1m-brands a'), 0, 6).forEach(function (l) { var im = l.querySelector('img'); tiles += '<a href="' + esc(l.getAttribute('href')) + '">' + (im ? '<img src="' + esc(im.getAttribute('src')) + '" alt="' + esc(im.alt) + '">' : esc(l.textContent.trim())) + '</a>'; });
      np.innerHTML = '<div class="n1d-cols">' + cols + '</div><div class="n1d-aside">' + (bi ? '<img class="n1d-b" src="' + esc(bi.src) + '" alt="">' : '') + '<div class="n1d-tiles">' + tiles + '</div></div>';
      np.classList.add('is-on');
    }
    var html = items.map(function (i) { return '<a class="n1-hd__link n1-hd__link--x" data-n1d-nav="' + i[0] + '" href="' + root + '/collections/' + i[0] + '">' + (ar ? i[1] : i[2]) + '</a>'; }).join('');
    html += '<a class="n1-hd__link n1-hd__link--x" href="' + root + '/pages/brands">' + (ar ? 'الماركات' : 'Brands') + '</a>';
    w.innerHTML = html;
    w.querySelectorAll('[data-n1d-nav]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a, a.getAttribute('data-n1d-nav')); });
      a.addEventListener('mouseleave', later);
    });
    np.addEventListener('mouseenter', function () { clearTimeout(timer); });
    np.addEventListener('mouseleave', later);
  }
  function hero() {
    var h = document.querySelector('.n1m-hero'), t = h && h.querySelector('[data-n1m-hero]'); if (!t) return;
    t.querySelectorAll('img').forEach(function (i) { i.loading = 'eager'; });
    var svg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    [['s', -1], ['e', 1]].forEach(function (d) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'n1d-ha n1d-ha--' + d[0]; b.innerHTML = svg; b.setAttribute('aria-label', d[1] < 0 ? (ar ? 'السابق' : 'Previous') : (ar ? 'التالي' : 'Next'));
      b.onclick = function () {
        var n = t.children.length, w = t.clientWidth, sign = document.documentElement.dir === 'rtl' ? -1 : 1;
        var i = Math.round(Math.abs(t.scrollLeft) / w) + d[1]; i = (i + n) % n;
        t.scrollTo({ left: sign * i * w, behavior: 'smooth' });
      };
      h.appendChild(b);
    });
  }
  function dedupe() {
    var seen = window.__n1seen || {}, r = document.querySelector('[id$="__rail_perf"] [data-n1-items]'); if (!r) return;
    [].slice.call(r.children).forEach(function (c) { var id = c.getAttribute('data-ksx-pid'); if (seen[id]) c.remove(); else seen[id] = 1; });
  }
  function start() {
    plp(); dedupe();
    if (wide) { nav(); hero(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
